module.exports = __webpack_public_path__ + "img/back.0679b27c.svg";